export default "__VITE_ASSET__DeyHeox$__"